import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import AircallWorkspace from "aircall-everywhere";
import { PhoneType } from "../../models/PhoneTypes";

const initialState: PhoneType= {
    phone: null,
    phoneVisible: false,
}
const phoneSlice = createSlice({
    name:'phone',
    initialState,
    reducers: {
        setPhoneVisible: (state, action: PayloadAction<boolean>) =>{
            state.phoneVisible = action.payload;
        },
        setPhone: (state, action: PayloadAction<AircallWorkspace>) =>{
            state.phone = action.payload
        }
    },
});

export const {setPhoneVisible, setPhone} = phoneSlice.actions;
export default phoneSlice.reducer;